// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

function NumberSelector(props) {
  return (
    <div className="input-group">
      <button
        tabIndex="3"
        className="input-group-addon btn decrement"
        disabled={props.value == 0}
        aria-label="Decrease amount of tickets"
        onClick={e => {
          e.preventDefault();
          if (props.value - 1 >= props.min) {
            props.handler(props.value - 1, props.priceType);
          }
        }}
        onKeyDown={e => {
          const code = e.charCode || e.keyCode || e.which;
          [13, 32].indexOf(code) !== -1 && props.value - 1 >= props.min
            ? props.handler(props.value - 1, props.priceType)
            : null;
        }}
      />
      <input
        tabIndex="3"
        aria-label="Amount"
        className="form-control input-qty"
        type="number"
        min="0"
        max={props.max}
        readOnly={true}
        value={props.value}
        onChange={e => {
          e.preventDefault();
          props.handler(e.target.value, props.priceType);
        }}
      />
      <button
        tabIndex="3"
        className="input-group-addon btn increment"
        disabled={props.value >= props.max}
        aria-label="Increase amount of tickets"
        onClick={e => {
          e.preventDefault();
          if (props.value + 1 <= props.max) {
            props.handler(props.value + 1, props.priceType);
          }
        }}
        onKeyDown={e => {
          const code = e.charCode || e.keyCode || e.which;
          [13, 32].indexOf(code) !== -1 && props.value + 1 <= props.max
            ? props.handler(props.value + 1, props.priceType)
            : null;
        }}
      />
    </div>
  );
}

NumberSelector.propTypes = {
  value: PropTypes.number,
  handler: PropTypes.func,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  priceType: PropTypes.object
};

export default NumberSelector;



// WEBPACK FOOTER //
// ./src/javascripts/components/NumberSelector.js